// extracted by mini-css-extract-plugin
export default {"content":"Dku2cDXIer_landings","full-screen":"V5_YVQ6prg_landings","curtain":"BKT5rsimK3_landings","container":"HFt8ZKx7YN_landings","sticky":"ty8BgIRvhA_landings"};